import React from 'react';
import Transporte from '../paquetes-detalle/detalle-pythagoras/paquete-detalle-transporte/paquete-detalle-transporte';
import PanelBasico from '../paquetes-detalle/panel-basico/panel-basico';
import Hoteles from '../paquetes-detalle/detalle-pythagoras/paquete-detalle-hoteles/paquete-detalle-hoteles';
import CityName from '../../commons/iataRenderService';
import './detalle.css';
import SeccionConTitulo from '../paquetes-detalle/seccion-detalle/seccion-con-titulo';

const DetallePythagoras = (props) => {
  const ciudadOrigen = <CityName code={props.paquete.salidas[0].origenIata} upperCase='true' />;
  const ciudadDestino = <CityName code={props.paquete.salidas[0].destinoIata.split(';')[1]} upperCase='true' />;

  return (
    <span className='confirmacion-pago'>
      <SeccionConTitulo titulo='Aéreos'>
        <Transporte
          origen={ciudadOrigen}
          destino={ciudadDestino}
          salida={props.paquete.salidas[0]}
        />
      </SeccionConTitulo>
      <SeccionConTitulo titulo='Alojamientos'>
        <Hoteles
          destinos={props.paquete.salidas[0].destinosHoteles}
          hoteles={props.paquete.salidas[0].hoteles}
        />
      </SeccionConTitulo>
      <SeccionConTitulo titulo='Descripción'>
        <PanelBasico
          titulo='Observaciones'
          contenido={props.paquete.salidas[0].observaciones[0]}
        />
      </SeccionConTitulo>
    </span>
  );
};

export default DetallePythagoras;
